import React, { useState, useEffect } from "react";
import { faEnvelope, faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import user from "../../Assets/Images/user.png";
import { Uploader, Button, Modal, InputPicker } from "rsuite";
import Select from "react-select";
import { ApiEndPoint, ApiToken } from "../../Data/Api";
import { countryListLocal } from "../../Data/CountryList";
import axios from "axios";
import { Tooltip, Whisper } from "rsuite";
import Plus from "@rsuite/icons/legacy/Plus";
// import { toast, ToastContainer } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../Components/Loader";
import { NavLink, useNavigate } from "react-router-dom";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { setLoginUser } from "../../reducers/hotelActions";
import { useDispatch } from "react-redux";
import { Country, City } from "country-state-city";
import pdf from "../../Assets/Images/pdf.webp";
function EditProfile({ userData }) {
  const token = ApiToken();
  const baseurl = ApiEndPoint();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cityList, setCityList] = useState([]);
  const [initialCity, setInitialCity] = useState([]);
  const [isClearable, setIsClearable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [modalCompanyDocs, setModalCompanyDocs] = useState(false);
  const [modalBillingDocs, setModalBillingDocs] = useState(false);

  const [filesUploadDocument, setFilesUploadDocument] = useState([]);

  const [paymentDocument, setPaymentDocument] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [fileIdProf, setFileIdProf] = useState(null);
  const [personalInfoErrors, setPersonalInfoErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    personalInfo: {
      firstName: userData.first_name,
      // lastName: userData.email,
      email: userData.email,
      position: userData.position,
    },
    companyInfo: {
      companyName: userData.company_name,
      address: userData.company_address,
      contactNo: userData.phone_no,
      website: userData.company_Website,
      country: userData.country,
      countryObj: null,

      city: userData.city,
      zipcode: userData.zip_code,
    },
    billingInfo: {
      accountName:
        userData.billing_Details === null ? "" : userData.account_Name,
      accountNumber:
        userData.billing_Details === null ? "" : userData.account_Number,
      IBAN: userData.billing_Details === null ? "" : userData.IBAN_Number,
      accountCredit:
        userData.billing_Details === null ? "" : userData.account_Credit,
    },
  });

  console.log(userData);

  useEffect(() => {
    const countryOptions = countryListLocal.item
      .filter(
        (country) =>
          country.name.common !== "Mayotte" &&
          country.name.common !== "United States Virgin Islands" &&
          country.name.common !== "Niue"
      ) // Exclude specified countries
      .map((country) => ({
        value: country.name.common,
        label: country.name.common,
        flag: country.flags.png,
        code: country.cca2,
        phoneCode:
          country.cca2 === "US"
            ? country.idd.root
            : country.idd.root + (country.idd.suffixes[0] || ""), // Handle case where suffixes may not exist
      }));
    const countryname = countryOptions.find(
      (item) => item.value === userData.country
    );
    handleselectCountry(countryname);
    setFormData((prev) => ({
      ...prev,
      companyInfo: {
        ...prev.companyInfo,
        countryObj: countryname,
        city: userData.city,
        country: countryname.label,
        contactNo: userData.phone_no,
        phnono: countryname.phoneCode,
      },
    }));

    setCountryList(countryOptions);
  }, []);
  function ValidEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }
  // console.log(userData);
  useEffect(() => {
    const imageUrl =
      "https://api.synchtravel.com/storage/app/public/b2b_Agents_Documents/id_Card/" +
      userData?.id_Card;

    if (userData?.id_Card !== null) {
      setFileList([
        {
          name: userData?.id_Card,
          fileKey: 1,
          url: imageUrl, // Keep the original URL for reference
        },
      ]);

      setFileIdProf(imageUrl); // Store the original URL
    }
  }, [userData]);
  const handlepersonalinfo = () => {
    let newErrors = {};
   if (!formData.personalInfo.firstName) {
  newErrors.firstName = "Please enter Full name.";
} else if (!/^[a-zA-Z\s]*$/.test(formData.personalInfo.firstName)) {
  newErrors.firstName = "Full Name cannot contain numbers or special characters.";
} else if (formData.personalInfo.firstName.trim().length < 2) {
  newErrors.firstName = "Name must be at least 2 characters.";
} else if (formData.personalInfo.firstName.length > 40) {
  newErrors.firstName = "Full name cannot be longer than 40 characters.";
}

    // if (!formData.personalInfo.lastName) {
    //   newErrors.lastName = "Please Enter Last Name.";
    // } else if (!/^[a-zA-Z\s]*$/.test(formData.personalInfo.lastName)) {
    //   newErrors.lastName = "Last Name cannot contain special characters.";
    // } else if (formData.personalInfo.lastName.length > 20) {
    //   newErrors.lastName = "Last Name cannot be longer than 20 characters.";
    // }

   if (!formData.personalInfo.position) {
  newErrors.position = "Please enter your position.";
} else if (formData.personalInfo.position.trim().length < 2) {
  newErrors.position = "Position must be at least 2 characters.";
}
 
    if (!formData.personalInfo.email) {
      newErrors.email = "Please Enter Email";
    } else if (!ValidEmail(formData.personalInfo.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    setPersonalInfoErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      return false;
    } else {
      return true;
    }
  };
   const handleFileChange = (fileList) => {
    const bytesInMB = 1048576;
    const validFiles = [];

    fileList.forEach((file) => {
      const fileSizeInMB = file.blobFile.size / bytesInMB;

      if (fileSizeInMB > 2) {
        toast.error(`File "${file.name}" exceeds the 2 MB limit.`);
      } else {
        validFiles.push(file);
      }
    });

    setFilesUploadDocument(validFiles); // Only allow valid files to show
  };

  const zipCodeRegex = /^[A-Za-z0-9\s\-]{3,10}$/;
  const handlecompanyinfo = () => {
    const bytesInMB = 1048576; // 1 MB in bytes
    let newErrors = {};
    if (!formData.companyInfo.companyName) {
      newErrors.companyName = "Please Enter Company Name";
    } else if (
      formData.companyInfo.companyName.length < 10 ||
      formData.companyInfo.companyName.length > 50
    ) {
      newErrors.companyName =
        "Company Name must be between 10 and 50 characters.";
    }
const trimmedAddress = formData.companyInfo.address.trim();

if (!trimmedAddress) {
  newErrors.address = "Please Enter Street no.";
} else if (trimmedAddress.length < 2) {
  newErrors.address = "Street must be at least 2 characters.";
}

    

    // else if (
    //   formData.companyInfo.address.length < 10 ||
    //   formData.companyInfo.address.length > 50
    // ) {
    //   newErrors.address = "Address must be between 10 and 50 characters.";
    // }
    if (!formData.companyInfo.country) {
      newErrors.country = "Please Select Country.";
    }
    if (!formData.companyInfo.city) {
      newErrors.city = "Please Select City.";
    }
    if (!formData.companyInfo.zipcode) {
      newErrors.zipcode = "Please Enter Postal code.";
    } else if (!zipCodeRegex.test(formData.companyInfo.zipcode)) {
      newErrors.zipcode = "Invalid Postal code format.";
    }
    if (!formData.companyInfo.contactNo) {
      newErrors.contactNo = "Please Enter Contact Number.";
    } else if (!/^\+?\d{8,14}$/.test(formData.companyInfo.contactNo)) {
      newErrors.contactNo = "Contact Number must be between 8 and 15 digits.";
    }

    // if (!formData.companyInfo.website) {
    //   newErrors.website = "Please Enter Website URL.";
    // } else if (
    //   formData.companyInfo.website.length < 10 ||
    //   formData.companyInfo.website.length > 50
    // ) {
    //   newErrors.website = "Website URL must be between 10 and 50 characters.";
    // }
    // if (!isValidURL(formData.companyInfo.website)) {
    //   newErrors.website = "Please enter a valid website URL, including 'http://' or 'https://'.";
    // }
    // if (!fileIdProf) {
    //   newErrors.fileIdProf = "Please Upload Id Proof.";
    // }

    // if (!userData.business_Document && filesUploadDocument.length === 0) {
    //   newErrors.filesUploadDocument = "Please Upload Business Document.";
    // }

     if (filesUploadDocument.length > bytesInMB) {
      newErrors.filesUploadDocument = "File size exceed";
      return;
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      return false;
    } else {
      return true;
    }
  };
  function isValidURL(url) {
    const pattern =
      /^(https?:\/\/)?([\w\d-]+\.)+[\w-]{2,}(\/[\w\d-_.~:?#[\]@!$&'()*+,;=]*)*\/?$/;
    return pattern.test(url);
  }
  const handlebillinginfo = () => {
    let newErrors = {};

    // if (!formData.billingInfo.accountName) {
    //   newErrors.accountName = "Please Enter Account Name";
    // } else if (
    //   formData.billingInfo.accountName.length < 10 ||
    //   formData.billingInfo.accountName.length > 50
    // ) {
    //   newErrors.accountName = "Account Name must be between 10 and 50 characters.";
    // }

    // if (!formData.billingInfo.accountNumber) {
    //   newErrors.accountNumber = "Please Enter Account Number";
    // } else if (
    //   formData.billingInfo.accountNumber.length < 8 ||
    //   formData.billingInfo.accountNumber.length > 20
    // ) {
    //   newErrors.accountNumber = "Account Number must be between 8 and 20 characters.";
    // }

    // if (!formData.billingInfo.IBAN) {
    //   newErrors.IBAN = "Please Enter IBAN.";
    // } else if (
    //   formData.billingInfo.IBAN.length < 8 ||
    //   formData.billingInfo.IBAN.length > 20
    // ) {
    //   newErrors.IBAN = "IBAN Number must be between 8 and 20 characters.";
    // }

    // if (!formData.billingInfo.accountCredit) {
    //   newErrors.accountCredit = "Please Enter Account Credit.";
    // }

    // if (!userData.account_Document && paymentDocument.length === 0) {
    //   newErrors.paymentDocument = "Please Upload Billing Documents.";
    // }
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      return false;
    } else {
      return true;
    }
  };
  const handleChange = (e, section) => {
    const { name, value } = e.target;

if (name === "firstName") {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    setPersonalInfoErrors((prev) => ({
      ...prev,
      [name]: "Please enter your full name.",
    }));
  } else if (trimmedValue.length < 2) {
    setPersonalInfoErrors((prev) => ({
      ...prev,
      [name]: "Name must be at least 2 characters.",
    }));
  } else if (trimmedValue.length > 40) {
    setPersonalInfoErrors((prev) => ({
      ...prev,
      [name]: "Full name cannot be longer than 40 characters.",
    }));
  } else if (!/^[a-zA-Z\s\-]+$/.test(trimmedValue)) {
    setPersonalInfoErrors((prev) => ({
      ...prev,
      [name]: "Full Name cannot contain numbers or special characters.",
    }));
  } else {
    setPersonalInfoErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  }
}


  if (name === "position") {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    setPersonalInfoErrors((prev) => ({
      ...prev,
      [name]: "Please enter your position.",
    }));
  } else if (trimmedValue.length < 2) {
    setPersonalInfoErrors((prev) => ({
      ...prev,
      [name]: "Position must be at least 2 characters.",
    }));
  } else {
    setPersonalInfoErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  }
}

    if (name === "zipcode") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Postal code.",
        }));
      } else if (!/^[A-Za-z0-9\s\-]{3,12}$/.test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]:
            "Postal Code must be 3–12 characters and can include letters, numbers, spaces, or hyphens.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "companyName") {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Company Name.",
        }));
      } else if (trimmedValue.length < 10 || trimmedValue.length > 50) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Company Name must be between 10 to 50 characters.",
        }));
      } else {
        // Valid input, remove error
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "address") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Street no.",
        }));
      } else {
        // Remove the error if input is valid
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "contactNo") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Contact Number.",
        }));
      } else if (!/^\+?\d{8,14}$/.test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Contact Number must be between 8 and 15 digits.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }
    setFormData({
      ...formData,
      [section]: {
        ...formData[section],
        [name]: value,
      },
    });
  };
 
  
  const handlePaymentFileChange = (fileList) => {
    const bytesInMB = 1048576; // 1 MB in bytes
    let hasLargeFile = false;
    fileList.forEach((file) => {
      const fileSizeInBytes = file.blobFile.size;
      const fileSizeInMB = fileSizeInBytes / bytesInMB;

      // If any file exceeds the size limit, show an error and stop processing
      if (fileSizeInMB > 2) {
        toast.error(`File "${file.name}" exceeds the maximum limit of 2 MB.`);
        hasLargeFile = true; // Mark that there is a large file
        return; // Break out of the loop
      }
    });
    if (hasLargeFile) {
      return;
    }
    setPaymentDocument(fileList);
  };

  const handleselectCountry = (value) => {
    if (value !== null) {
      const allcity = City.getCitiesOfCountry(value.code);

      const uniqueCities = allcity.filter(
        (city, index, self) =>
          index === self.findIndex((c) => c.name === city.name)
      );

      const cityOptions = uniqueCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));

      setInitialCity(cityOptions.slice(0, 130));
      setCityList(cityOptions);
    } else {
      setInitialCity([]);
      setCityList([]);
    }

    const cont = countryList.find((item) => item.code === value?.code);

    setFormData((prev) => ({
      ...prev,
      companyInfo: {
        ...prev.companyInfo,
        country: cont?.label || "",
        city: "",
        phnono: cont?.phoneCode || "",
        countryObj: value,
        contactNo: cont?.phoneCode || "",
      },
    }));

    // ✅ Validation
    setErrors((prev) => {
      const newErrors = { ...prev };
      if (!value) {
        newErrors.country = "Please Select Country.";
      } else {
        delete newErrors.country;
      }
      return newErrors;
    });
  };
  const previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };
  const removeImage = () => {
    setFileIdProf(null); // Clears the previewed image
    setUploading(false); // Resets uploading state
  };

  const handleUpload = (file) => {
    const bytesInMB = 1048576;
    const fileSizeInBytes = file.blobFile.size;
    const fileSizeInMB = fileSizeInBytes / bytesInMB;
    if (fileSizeInMB > 2) {
      toast.error("File size exceeds the maximum limit of 2 MB.");
      return;
    }
    setUploading(true);
    previewFile(file.blobFile, (value) => {
      setFileIdProf(value);
      setUploading(false);
    });
  };

  const handleCreateCity = (value) => {
    const newCity = {
      label: value,
      value: value.toLowerCase().replace(/\s+/g, "-"),
    };

    setCityList((prev) => [...prev, newCity]); // Add new city to options
  };

 
  console.log(cityList);

  const handleSubmit = async () => {
    if (handlepersonalinfo()) {
      return;
    }

    if (handlecompanyinfo()) {
      return;
    }

    // if (handlebillinginfo()) {
    //   return;
    // }
    const submitData = new FormData();
    submitData.append("id", userData.id);
    submitData.append("token", token);
    submitData.append("email", formData.personalInfo.email);
    submitData.append("password", formData.personalInfo.password);
    submitData.append("title", ""); // Title is empty in the original data
    submitData.append("first_name", formData.personalInfo.firstName);
    submitData.append("last_name", formData.personalInfo.lastName);
    submitData.append("company_name", formData.companyInfo.companyName);
    submitData.append("company_address", formData.companyInfo.address);
    submitData.append(
      "company_Website",
      formData.companyInfo.website === null ? "" : formData.companyInfo.website
    );
    submitData.append("country", formData.companyInfo.country); // Country is empty in the original data
    submitData.append("city", formData.companyInfo.city); // City is empty in the original data
    submitData.append("phone_no", formData.companyInfo.contactNo);
    submitData.append("company_Phone_no", formData.companyInfo.contactNo);
    submitData.append("position", formData.personalInfo.position);
    submitData.append("zip_code", formData.companyInfo.zipcode); // Zip code is empty in the original data
    submitData.append("otp_code", ""); // OTP code is empty in the original data
    submitData.append("personal_Details", "");
    submitData.append("billing_Details", "");
    submitData.append("comapany_Details", "Active");
    // submitData.append("id_Card", fileIdProf);
    if (fileList[0]?.blobFile) {
      submitData.append("id_Card", fileIdProf);
    }
    if (filesUploadDocument.length !== 0) {
      filesUploadDocument.forEach((item, index) => {
        submitData.append(
          `business_Document[${index}]`,
          item.blobFile,
          item.name
        );
      });
    }
    // submitData.append("account_Name", formData.billingInfo.accountName);
    // submitData.append("account_Number", formData.billingInfo.accountNumber);
    // submitData.append("IBAN_Number", formData.billingInfo.IBAN);
    // submitData.append("account_Credit", formData.billingInfo.accountCredit);
    // submitData.append("", "");
    // if (paymentDocument.length !== 0) {
    //   paymentDocument.forEach((item, index) => {
    //     submitData.append(
    //       `account_Document[${index}]`,
    //       item.blobFile,
    //       item.name
    //     );
    //   });
    // }

    setIsLoading(true);
    try {
      const response = await axios.post(
        baseurl + "/api/update/customer/submit",
        submitData,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setIsLoading(false);
      if (response.data.status === "success") {
        dispatch(setLoginUser(response.data.b2b_agent));
        toast.success("Your profile update successfully.");
        navigate("/dashboard/profile");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error:", error);
    }
  };
  const CompanyDocsModalChange = () => {
    setModalCompanyDocs(!modalCompanyDocs);
  };
  const BillingDocsModalChange = () => {
    setModalBillingDocs(!modalBillingDocs);
  };

  const handleselectCity = (value) => {
    setFormData((prev) => ({
      ...prev,
      companyInfo: {
        ...prev.companyInfo,
        city: value,
      },
    }));

    setErrors((prev) => {
      const newErrors = { ...prev };
      if (!value) {
        newErrors.city = "Please Select City.";
      } else {
        delete newErrors.city;
      }
      return newErrors;
    });
  };
  return (
    <>
      <Modal open={modalCompanyDocs} onClose={CompanyDocsModalChange}>
        <Modal.Header>
          <Modal.Title>Company Business Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-3">
            <div
              style={{ flexWrap: "wrap" }}
              className="d-flex align-items-center"
            >
              {userData.business_Document !== undefined &&
                userData.business_Document !== null &&
                JSON.parse(userData.business_Document).map((item, index) => {
                  // Get the file extension to differentiate between image and PDF
                  const fileExtension = item.split(".").pop().toLowerCase();
                  const isImage = ["jpg", "jpeg", "png", "gif"].includes(
                    fileExtension
                  );
                  const fileUrl =
                    "https://api.synchtravel.com/public/uploads/b2b_Agents_Documents/business_Document/" +
                    item;

                  return (
                    <div key={index} style={{ margin: "10px" }}>
                      {isImage ? (
                        // Render image if it's an image file
                        <img
                          style={{
                            width: "auto",
                            height: "10em",
                            objectFit: "cover",
                          }}
                          src={fileUrl}
                          alt={`Document ${index + 1}`}
                        />
                      ) : (
                        // Render a link or icon for PDFs
                        <a
                          href={fileUrl}
                          target="_blank"
                          style={{ textDecoration: "none" }}
                          className="text-center"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={pdf} // Add a generic PDF icon here
                            alt={`PDF Document ${index + 1}`}
                            style={{
                              width: "auto",
                              height: "10em",
                              objectFit: "cover",
                            }}
                          />
                          <p>PDF Document {index + 1}</p>
                        </a>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end align-items-center">
          <button
            className="btn ms-2 btn-secondary text-dark"
            onClick={CompanyDocsModalChange}
          >
            close
          </button>
        </Modal.Footer>
      </Modal>
      <Modal open={modalBillingDocs} onClose={BillingDocsModalChange}>
        <Modal.Header>
          <Modal.Title>Account Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-3">
            <div
              style={{ flexWrap: "wrap" }}
              className="d-flex align-items-center"
            >
              {userData.account_Document !== undefined &&
                userData.account_Document !== null &&
                JSON.parse(userData.account_Document).map((item, index) => {
                  // Get the file extension to differentiate between image and PDF
                  const fileExtension = item.split(".").pop().toLowerCase();
                  const isImage = ["jpg", "jpeg", "png", "gif"].includes(
                    fileExtension
                  );
                  const fileUrl =
                    "https://api.synchtravel.com/public/uploads/b2b_Agents_Documents/account_Document/" +
                    item;

                  return (
                    <div key={index} style={{ margin: "10px" }}>
                      {isImage ? (
                        // Render image if it's an image file
                        <img
                          style={{
                            width: "auto",
                            height: "10em",
                            objectFit: "cover",
                          }}
                          src={fileUrl}
                          alt={`Document ${index + 1}`}
                        />
                      ) : (
                        // Render a link or icon for PDFs
                        <a
                          href={fileUrl}
                          target="_blank"
                          style={{ textDecoration: "none" }}
                          className="text-center"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={pdf} // Add a generic PDF icon here
                            alt={`PDF Document ${index + 1}`}
                            style={{
                              width: "auto",
                              height: "10em",
                              objectFit: "cover",
                            }}
                          />
                          <p>PDF Document {index + 1}</p>
                        </a>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end align-items-center">
          <button
            className="btn ms-2 btn-secondary"
            onClick={BillingDocsModalChange}
          >
            close
          </button>
        </Modal.Footer>
      </Modal>
      {/* <ToastContainer /> */}
      <Toaster position="top-right" reverseOrder={false} />
      {isLoading && <Loader />}
      <div className="card-header bg-transparent ">
        <h4 className="card-header-title">
          <FontAwesomeIcon icon={faUserCircle} /> Edit My Profile
        </h4>
      </div>
      <div className="profile_card card mt-4">
        <div className="card-body profile-user-box">
          <div className="row">
            <div className="col-sm-8">
              <div className="row align-items-center">
                <div className="col-auto">
                  <div className="avatar-lg">
                    <img
                      src={user}
                      alt=""
                      className="rounded-circle img-thumbnail"
                    />
                  </div>
                </div>
                <div className="col">
                  <div>
                    <h4 className="mt-1 mb-1 text-white">
                      {userData?.first_name}
                    </h4>
                    <p className="font-13 text-white-50">
                      {" "}
                      <FontAwesomeIcon icon={faEnvelope} /> {userData?.email}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Personal-info-form">
        <h4 className="mt-3">Personal Information</h4>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Full Name</label>
              <input
                className="form-control mt-2"
                type="text"
                autoComplete="off"
                name="firstName"
                value={formData.personalInfo.firstName}
                onChange={(e) => handleChange(e, "personalInfo")}
                placeholder="Enter your first name"
              />
              {personalInfoErrors.firstName && (
                <span className="text-danger">
                  {personalInfoErrors.firstName}
                </span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Email</label>
              <input
                className="form-control mt-2"
                type="text"
                name="email"
                disabled
                value={formData.personalInfo.email}
                onChange={(e) => handleChange(e, "personalInfo")}
                placeholder="Enter your Email"
              />
              {personalInfoErrors.email && (
                <span className="text-danger">{personalInfoErrors.email}</span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Position</label>
              <input
                className="form-control mt-2"
                type="text"
                autoComplete="off"
                name="position"
                value={formData.personalInfo.position}
                onChange={(e) => handleChange(e, "personalInfo")}
                placeholder="Enter your Position"
              />
              {personalInfoErrors.position && (
                <span className="text-danger">
                  {personalInfoErrors.position}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="company-info-form">
        <h4 className="mt-3">Company Information</h4>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Company Name</label>
              <input
                className="form-control mt-2"
                type="text"
                name="companyName"
                value={formData.companyInfo.companyName}
                onChange={(e) => handleChange(e, "companyInfo")}
                placeholder="abc company"
              />
              {errors.companyName && (
                <span className="text-danger">{errors.companyName}</span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-4">
              <label>Country</label>

              <Select
                options={countryList}
                isSearchable={true}
                isClearable={isClearable}
                className=""
                onChange={handleselectCountry}
                value={formData.companyInfo.countryObj}
                getOptionLabel={(option) => (
                  <div>
                    <img
                      src={option.flag}
                      alt={option.label}
                      style={{ width: "20px", marginRight: "8px" }}
                    />
                    {option.label}
                  </div>
                )}
                getOptionValue={(option) => option.value}
              />

              {errors.country && (
                <span className="text-danger">{errors.country}</span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-4">
              <label>City</label>

              <InputPicker
                data={cityList}
                labelKey="label"
                valueKey="value"
                creatable
                onCreate={handleCreateCity}
                value={formData.companyInfo.city}
                onChange={handleselectCity}
                searchable={true}
                virtualized
                searchBy={(keyword, label) =>
                  label.toLowerCase().includes(keyword.toLowerCase())
                } // Custom search function for efficiency
                placeholder="Select a city..."
                // menuMaxHeight={320} // Set max height to avoid displaying too many items
                style={{ width: "100%" }}
              />
              {errors.city && (
                <span className="text-danger">{errors.city}</span>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Contact No</label>
              <input
                className="form-control mt-2"
                type="text"
                onKeyPress={(event) => {
                  if (!/[0-9+]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                name="contactNo"
                value={formData.companyInfo.contactNo}
                onChange={(e) => handleChange(e, "companyInfo")}
                placeholder="+123 456 7899"
              />
              {errors.contactNo && (
                <span className="text-danger">{errors.contactNo}</span>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group mt-3">
              <label>Street</label>
              <input
                className="form-control mt-2"
                type="text"
                name="address"
                value={formData.companyInfo.address}
                onChange={(e) => handleChange(e, "companyInfo")}
                placeholder="street 123"
              />
              {errors.address && (
                <span className="text-danger">{errors.address}</span>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Postal Code</label>
              <input
                className="form-control mt-2"
                type="text"
                name="zipcode"
                value={formData.companyInfo.zipcode}
                onChange={(e) => handleChange(e, "companyInfo")}
                placeholder="Please Enter Postal Code"
              />
              {errors.zipcode && (
                <span className="text-danger">{errors.zipcode}</span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Website</label>
              <input
                className="form-control mt-2"
                type="text"
                name="website"
                value={formData.companyInfo.website}
                onChange={(e) => handleChange(e, "companyInfo")}
                placeholder="www.example.com"
              />
              {/* {errors.website && <span className="text-danger">{errors.website}</span>} */}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group d-upload mt-3">
              <div className="d-flex justify-content-between">
                <label>
                  Upload Business Document{" "}
                  {userData?.business_Document !== null && (
                    <Whisper
                      placement="top"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={
                        <Tooltip>
                          {" "}
                          If you want to change your business document, upload a
                          new one. Otherwise, leave it empty.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Whisper>
                  )}
                </label>
                <p
                  onClick={CompanyDocsModalChange}
                  className="text-primary cursor-pointer"
                >
                  Previous Documents
                </p>
              </div>
              <div>
                <Uploader
                  className="mt-2"
                  fileList={filesUploadDocument}
                  listType="picture-text"
                  accept=".png, .jpg, .jpeg, .pdf"
                  onChange={handleFileChange}
                  autoUpload={false}
                  action="//jsonplaceholder.typicode.com/posts/"
                >
                  <Button>Select files...</Button>
                </Uploader>
               {errors.filesUploadDocument && (
                            <span className="text-danger">
                              {errors.filesUploadDocument}
                            </span>
                          )}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Upload ID</label>
              <div>
                <Uploader
                  fileList={[]}
                  onChange={(files) => {
                    setFileList(files); // Update the file list with the new file
                  }}
                  listType="picture"
                  accept=".png, .jpg, .jpeg"
                  action="//jsonplaceholder.typicode.com/posts/"
                  fileListVisible={false}
                  onUpload={handleUpload}
                >
                  <button style={{ width: 300, height: 150 }}>
                    {uploading && <Loader backdrop center size="md" />}
                    {fileIdProf ? (
                      <img
                        src={fileIdProf}
                        alt="Preview"
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      <Plus style={{ fontSize: 20 }} />
                    )}
                  </button>
                </Uploader>
              </div>
              {/* {errors.fileIdProf && <span className="text-danger">{errors.fileIdProf}</span>} */}
              {fileIdProf && (
                <div className="text-center">
                  <Button appearance="link" color="red" onClick={removeImage}>
                    Remove
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="Billing-info-form">
        <h4 className="mt-3">Billing Information</h4>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Account Name</label>
              <input
                className="form-control mt-2"
                type="text"
                name="accountName"
                value={formData.billingInfo.accountName}
                onChange={(e) => handleChange(e, "billingInfo")}
                placeholder="xyz"
              />
              {errors.accountName && <span className="text-danger">{errors.accountName}</span>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Account Number</label>
              <input
                className="form-control mt-2"
                type="text"
                name="accountNumber"
                value={formData.billingInfo.accountNumber}
                onChange={(e) => handleChange(e, "billingInfo")}
                placeholder="street 123"
              />
              {errors.accountNumber && <span className="text-danger">{errors.accountNumber}</span>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>IBAN</label>
              <input
                className="form-control mt-2"
                type="text"
                name="IBAN"
                value={formData.billingInfo.IBAN}
                onChange={(e) => handleChange(e, "billingInfo")}
                placeholder="S000 1234567 89"
              />
               {errors.IBAN && <span className="text-danger">{errors.IBAN}</span>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Account Credit</label>
              <input
                className="form-control mt-2"
                name="accountCredit"
                value={formData.billingInfo.accountCredit}
                onChange={(e) => handleChange(e, "billingInfo")}
                type="text"
              />
               {errors.accountCredit && <span className="text-danger">{errors.accountCredit}</span>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group Billing mt-3">
            <div className='d-flex justify-content-between'>
              <label>
                Upload Account Document{" "}
                {userData?.account_Document !== null && (
                  <Whisper
                    placement="top"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={
                      <Tooltip>
                        If you want to change your business document, upload a
                        new one. Otherwise, leave it empty.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Whisper>
                )}
              </label>
              <p onClick={BillingDocsModalChange} className="text-primary cursor-pointer">Previous Documents</p>

              </div>
              <div>
                <Uploader
                  className="mt-2"
                  accept=".png, .jpg, .jpeg, .pdf"
                  defaultFileList={paymentDocument}
                  listType="picture-text"
                  onChange={handlePaymentFileChange}
                  autoUpload={false}
                  action="//jsonplaceholder.typicode.com/posts/"
                >
                  <Button>Select files...</Button>
                </Uploader>
                {errors.paymentDocument && <span className="text-danger">{errors.paymentDocument}</span>}
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="text-center my-4">
        <NavLink to="/dashboard/profile">
          <button className="theme-btn-danger-1 me-2 ps-4 pe-4 py-2">
            Cancel
          </button>
        </NavLink>
        <button onClick={handleSubmit} className="theme-btn-1 ps-4 pe-4 py-2">
          Submit
        </button>
      </div>
    </>
  );
}
export default EditProfile;
